import { FC } from 'react';
import { MaType } from '@shared/types';
import { TradingFormField } from '../../trading-form-field';
import { IndicatorIndexedPath } from '../indicator-config-form.utils';
import { useWatch } from 'react-hook-form';
import { useTradingFormContext } from '../../trading-form-context';

type RsiFieldsProps = {
  path: IndicatorIndexedPath;
};

export const RsiFields: FC<RsiFieldsProps> = ({ path }) => {
  const { control } = useTradingFormContext();
  const isMaChecked = !!useWatch({ control, name: `${path}.ma` });

  return (
    <>
      <TradingFormField type="numeric" name={`${path}.period`} label="Period" />
      <TradingFormField
        type="checkbox"
        name={`${path}.ma`}
        label="Moving Average"
        checked={isMaChecked}
        onChange={(checked) => (checked ? { type: 'MA' } : undefined)}
        wrapperProps={{ sx: { flexDirection: 'row' } }}
      />
      {isMaChecked && (
        <>
          <TradingFormField
            type="numeric"
            name={`${path}.ma.period`}
            label="MA Period"
          />
          <TradingFormField
            type="select"
            name={`${path}.ma.maType`}
            label="MA Type"
            defaultValue={MaType.SMA}
            options={Object.values(MaType)}
          />
        </>
      )}
    </>
  );
};
